let theme = {
  primaryButton: '#21153B',
  secondaryButton: '#8C5AFB',
  gray: '#f8f9fa',
  violet: '#8C5AFB',
  dark: '#21153B',
  teal: '#21B9A7',
  yellow: '#F0E78B',
  gradientBackground: 'linear-gradient(to bottom,#8C5AFB 0,#f8f9fa 100%)',
  darkGradientBackground: 'linear-gradient(to bottom,#21153B 0,#8C5AFB 100%)',
  lightGradientBackground: 'linear-gradient(to bottom,#8C5AFB 0,#fff 100%)'
};

export default theme;
